import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LazyPreShowMain } from "@faire/retailer-visitor-shared/views/promotional-events/pre-show/__internal__/LazyPreShowMain";
import { Route } from "@faire/web--source/ui/routing/Route";
import { Switch } from "@faire/web--source/ui/routing/Switch";
import { props as allSpecialsProps } from "@faire/web-api--source/routes/markets/event_type/all-specials";
import { props as myMarketListProps } from "@faire/web-api--source/routes/markets/event_type/all-specials/my-market-list";
import React from "react";
export var PreShowRouter = function() {
    return /*#__PURE__*/ _jsxs(Switch, {
        children: [
            /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, myMarketListProps), {
                component: LazyPreShowMain
            })),
            /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, allSpecialsProps), {
                component: LazyPreShowMain
            }))
        ]
    });
};
